import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Checkbox, List, Segment } from 'semantic-ui-react';
import { convertHelpers } from '../../../global/common/convert';
import { uniqueKey } from '../../../global/common/keys';
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons';
import { createRefPath_client } from '../../../global/firestoreData/appData/appRefPaths';
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import GolfCourse from './GolfCourse';
import GolfCourseFetch from './GolfCourseFetch';
import { scorecardTypes } from './Scorecard';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

const _collectionName_golfCourses = '_golfCourses'

const GolfCourses = (props) => {

  const { handleSave, handleCancel, golfCourseKey } = props ?? {}

  const parentContext = useContext(ParentContext)
  const { fns } = parentContext ?? {}
  const { database_fns } = fns ?? {}

  // golfParentContext
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states } = golfParent_contexts ?? {}
  const { paps_state } = states ?? {}

  const { pathViews } = paps_state ?? {}

  const [golfCourses, setGolfCourses] = useState()
  const [selectedCourse, setSelectedCourse] = useState(golfCourseKey)
  const [selectedGolfCourse, setSelectedGolfCourse] = useState()
  const [selectedCourseEdit, setSelectedCourseEdit] = useState()
  const [showAddNew, setShowAddNew] = useState()

  useEffect(() => {
    const cb = (res) => {
      const { golfCourses: _golfCourses } = res ?? {}
      const { golfCourses } = _golfCourses ?? {}
      convertHelpers.createItemKeys(golfCourses)
      const sorted = _.sortBy(golfCourses, 'name')
      setGolfCourses(sorted)
    }
    const _ref = createRefPath_client(pathViews, [_collectionName_golfCourses])
    console.log('_ref', _ref)
    database_fns.get_data({ refPath: _ref, callback: cb })
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const handleUpdate = () => {
    const { _itemKey } = selectedGolfCourse
    const _ref = createRefPath_client(pathViews, [_collectionName_golfCourses, 'golfCourses'])
    const data = {
      ['golfCourses']: {
        [_itemKey]: selectedGolfCourse
      }
    }
    console.log('_ref', _ref)
    console.log('data', data)
    database_fns.doc_set(_ref, data, true)
  }

  const handleCheck = (key, checked) => {
    if (checked && selectedCourse === key) {
      setSelectedCourse()
    } else {
      setSelectedCourse(key)
    }
  }

  const handleClick = (key) => {
    const gc = _.find(golfCourses, { _itemKey: key })
    setSelectedCourseEdit(gc)
  }

  const handleAddNew = (key) => {
    setShowAddNew(!showAddNew)
  }

  const handleAmmendScorecard = (selectedGolfCourse) => setSelectedGolfCourse(selectedGolfCourse)

  const listCheck = (key) => {
    if (handleSave) {
      const checked = selectedCourse === key
      return <Checkbox checked={checked} onClick={(e) => { handleCheck(key, checked) }} />
    }
  }
  const content = () => {
    const listItems = []
    if (golfCourses) {
      golfCourses.forEach(golfCourse => {
        const { _itemKey, name } = golfCourse ? golfCourse : {}
        listItems.push(<List.Item key={uniqueKey('gc', _itemKey)} onClick={(e) => { !handleSave && handleClick(_itemKey) }}>
          <List.Content floated='left'>
            {listCheck(_itemKey)}
          </List.Content>
          <List.Content>{name}</List.Content>
        </List.Item>)
      })
    }
    listItems.unshift(<List.Item key={uniqueKey('gc', 'new')} onClick={(e) => { handleAddNew() }}>
      <List.Content>{'Add New Course'}</List.Content>
    </List.Item>)

    return <Segment basic><List className={'list-check'} divided relaxed>{listItems}</List></Segment>
  }

  const wrapper = () => <Wrapper
    content={content()}
    footer={<UiSaveButtons save={{ oc: handleUpdate, caption: 'Update Round Golf Course' }} />}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'app-dark-mode' }}
  />

  const wrapper_golfCourse = () => <Wrapper
    content={<GolfCourse golfCourse={selectedCourseEdit} scorecardType={scorecardTypes.normal} handleAmmendScorecard={handleAmmendScorecard} />}
    footer={<UiSaveButtons save={{ oc: handleUpdate }} />}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_golfCourseAdd = () => <FullPageWrapper
    content={<GolfCourseFetch />}
    handleCancel={setShowAddNew}
    topperCaption={'Edit Course'}
    isBack={true}
  ></FullPageWrapper>

  const fpw_golfCourse = () => <FullPageWrapper
    content={wrapper_golfCourse()}
    handleCancel={setSelectedCourseEdit}
    topperCaption={'Edit Course'}
    isBack={true}
  ></FullPageWrapper>

  if (handleSave) {
    return <FullPageWrapper
      content={wrapper()}
      handleCancel={handleCancel}
      topperCaption={'Select Round Golf Course'}
      isBack={true}
    ></FullPageWrapper>
  } else {
    if (selectedCourseEdit) {
      return fpw_golfCourse()
    } else if (showAddNew) {
      return fpw_golfCourseAdd()
    } else {
      return content()
    }
  }

}

export default GolfCourses